var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BAspect, BCard, BCardHeader, BCardBody, BCardFooter, BCardImg } from 'bootstrap-vue';
let MountKitDesignOption = class MountKitDesignOption extends Vue {
    get imgSrc() {
        return `/api/visualisations/mountboard?width=${this.externalSize.width}&length=${this.externalSize.length}&apWidth=${this.apertureSize.width}&apLength=${this.apertureSize.length}&code=${this.boardCode}`;
    }
    get externalSize() {
        return {
            width: Math.min(this.frameSize.width, this.frameSize.length),
            length: Math.max(this.frameSize.width, this.frameSize.length)
        };
    }
    get apertureSize() {
        return {
            width: Math.min(this.itemSize.width, this.itemSize.length) - 6,
            length: Math.max(this.itemSize.width, this.itemSize.length) - 6,
        };
    }
    get altText() {
        return `${this.frameSize.name} to fit ${this.itemSize.name} ${this.boardCode} Mount Kit`;
    }
};
__decorate([
    Prop(Object)
], MountKitDesignOption.prototype, "frameSize", void 0);
__decorate([
    Prop(Object)
], MountKitDesignOption.prototype, "itemSize", void 0);
__decorate([
    Prop(String)
], MountKitDesignOption.prototype, "boardCode", void 0);
__decorate([
    Prop(String)
], MountKitDesignOption.prototype, "fromPrice", void 0);
__decorate([
    Prop(Boolean)
], MountKitDesignOption.prototype, "selected", void 0);
MountKitDesignOption = __decorate([
    Component({
        components: {
            BAspect, BCard, BCardHeader, BCardBody, BCardFooter, BCardImg
        }
    })
], MountKitDesignOption);
export default MountKitDesignOption;
